<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">{{ value.id ? 'Modifier' : 'Créer' }} une emprise</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Nom de l'emprise <b>(obligatoire)</b>
                    <CustomInputUniqChecker
                        required
                        class="stretch"
                        v-model="value.name"
                        :err-msg="`Le nom ${value.name} existe déjà`"
                        url="/api/check/footprint/name"
                    />
                </label>
            </div>
            <div class="form-control">
                <label> Géométrie de l'emprise (polygone GeoJSON simple en 4326) </label>
                <label>
                    <CustomInput
                        type="file"
                        class="stretch"
                        placeholder="Fichier GeoJSON"
                        @change="handleFileUpload"
                    />
                </label>
            </div>
            <div class="form-control" v-if="geom">
                <label id="label_map">Aperçu de l'emprise actuelle</label>
                <label> <FormMap :value="geom" /> </label>
            </div>
            <div class="form-control">
                <!-- v-if="value.default !== true" -->
                <label>
                    Utilisateurs
                    <CustomSelect
                        class="stretch"
                        placeholder="Sélectionnez les utilisateurs"
                        :options="users"
                        :multiple="true"
                        v-model="value.users"
                    />
                </label>
            </div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="stretch default" @click="$emit('close')">
                    Enregistrer
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomInput from './../Input';
import CustomButton from './../Button';
import CustomSelect from './../Select';
import FormMap from './../FormMap';
import CustomInputUniqChecker from './../InputUniqChecker';

export default {
    props: ['value', 'users'],
    data() {
        return {
            geom: null,
        };
    },
    mounted() {
        if (this.value.geom) {
            this.geom = this.value.geom;
        }
    },
    components: {
        Modal,
        CustomInput,
        CustomButton,
        CustomSelect,
        CustomInputUniqChecker,
        FormMap,
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                var reader = new FileReader();
                reader.readAsText(file, 'UTF-8');
                reader.onload = (evt) => {
                    try {
                        this.value.geojson = JSON.parse(evt.target.result);
                        this.geom = this.value.geojson;
                    } catch (error) {
                        console.error('error reading file : JSON not valid', evt.target.result);
                    }
                };
                reader.onerror = (evt) => {
                    console.error('error reading file', evt);
                };
            }
        },
    },
};
</script>

<style lang="scss">
#label_map {
    padding-bottom: 10px;
    display: inline-block;
}
</style>
